import { compact as s } from "../arrays/utils.js";
import { fMap as c, optional as l } from "../fp/optional/utils.js";
const m = (t) => t.trim().length === 0, a = (t) => c(l(t), (n) => m(n) ? void 0 : n.trim()), p = (t, n) => s(t.split(n).map(a)), d = (t) => p(t, /\r?\n/), x = (t, n) => {
  const e = t.split(/\r?\n/), o = [];
  for (let i = 0; i < e.length; i += 1) {
    const r = e[i].trim();
    r.length !== 0 && (n.test(r) || o.push(i + 1));
  }
  return o;
}, g = (t, n, e) => t === 1 ? n : e ?? `${n}s`, N = (t, n) => `${t}x${n}`, $ = (t) => t.replaceAll("x", "×"), k = (t, n = !0) => {
  if (t.length === 0)
    return t;
  const e = t.slice(1);
  return t.charAt(0)?.toUpperCase() + (n ? e?.toLowerCase() : e);
}, u = (t) => {
  const n = /(\d+)\s*[xX×]\s*(\d+)/.exec(t);
  return n ? { width: Number(n[1]), height: Number(n[2]) } : null;
}, v = (t) => {
  const n = u(t);
  if (n)
    return `${n.width}x${n.height}`;
};
export {
  k as capitalize,
  x as collectInvalidLineNumbers,
  v as extractDimensionString,
  N as formatDimension,
  $ as formatDimensionSize,
  m as isBlank,
  u as parseDimensions,
  g as pluralize,
  d as splitNonEmptyLines,
  p as splitNonEmptyTokens,
  a as takeNotBlank
};
//# sourceMappingURL=utils.js.map
